import styled from 'styled-components';
import { Scrollbars } from '../../mixins'; // Adjust the import path as needed
import { COLOR, FONT_SIZE, SIZE } from '../../styles'; // Adjust the import path as needed

/*
 * This file contains all of the Table building blocks: TableContainer, Table, TableHead, TableRow, TableCell
 * You can make use of these building blocks to create your own Table component or use one that is already built (for e.g. BasicTable)
 */

export const TableContainer = styled.div`
  height: 100%;
  overflow: auto;

  ${Scrollbars({
    width: '0.6em',
    height: '0.6em',
    border: '0.5px',
    foregroundColor: 'rgba(150, 150, 150, 0.5)',
    backgroundColor: 'transparent',
  })};
`;

export const Table = styled.table`
  border-collapse: collapse;
  text-align: left;
  width: 100%;

  tbody > tr:hover {
    background-color: ${COLOR['light-gray-lightest']};
  }
`;

export const TableHead = styled.thead``;

export const TableBody = styled.tbody``;

export const TableFoot = styled.tfoot``;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${COLOR['light-gray-light']};
`;

export const TableCell = styled.td<{ active?: boolean }>`
  color: ${COLOR['dark-gray-dark']};
  font-size: ${FONT_SIZE['14']};
  font-weight: 400;
  height: 40px;
  overflow: hidden;
  padding: ${SIZE['8']};

  ${(props) =>
    props.active &&
    `
    background-color: ${COLOR['light-gray-lightest']};
  `};
`;

export const TableCellHeader = styled.th<{ width?: number; active?: boolean }>`
  cursor: pointer;
  width: ${(props) => props.width ?? 'auto'};
  color: ${COLOR['dark-gray-lightest']};
  font-size: ${FONT_SIZE['14']};
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  overflow: hidden;
  padding: ${SIZE['8']};

  ${(props) =>
    props.active &&
    `
    font-weight: 600;
    color: ${COLOR['dark-gray']};
  `};
`;
